import { Component, Inject, OnInit } from '@angular/core';
import { MerchantUserRolesEnum, TypeMerchantUserEnum } from '../../../../../../models';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { MerchantUserService } from 'app/services';

@Component({
  selector: 'role-permissions',
  templateUrl: './role-permissions.component.html',
  styleUrl: './role-permissions.component.scss'
})
export class RolePermissionsComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private messageService: MessageService,
        public merchantUserService: MerchantUserService
    ){}

    public storeRoles: any[] = [
        {
            id: MerchantUserRolesEnum.StoreManager,
            name: 'Store Manager'
        },
        {
            id: MerchantUserRolesEnum.Cashier,
            name: 'Cashier'
        },
        {
            id: MerchantUserRolesEnum.Dispatcher,
            name: 'Dispatcher'
        }
    ];
    public adminRoles: any[] = [
        {
            id: MerchantUserRolesEnum.Administrator,
            name: 'Administrator'
        },
        {
            id: MerchantUserRolesEnum.Operations,
            name: 'Operations'
        },
        {
            id: MerchantUserRolesEnum.Marketing,
            name: 'Marketing'
        },
        {
            id: MerchantUserRolesEnum.Finance,
            name: 'Finance'
        }
    ];

    public typesMerchantEmployee = TypeMerchantUserEnum;
    public roleRights: any[] = [];
    public groupedRoleRights: any[] = [];
    public loading: boolean = false;
    public uniqueGroupNames: any[] = [];

    ngOnInit(): void {
        this.getUserRoleRights();
    }

    public getUserRoleRights() {
        const dto = {
            IsAdmin: this.data.type === TypeMerchantUserEnum.WebAdmins
        };

        this.merchantUserService.getUserRoleRights(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.roleRights = data.Items;
                this.uniqueGroupNames = [...new Set(data.Items.map((item: { GroupName: any }) => item.GroupName))];

                this.groupRoleRights();
            })
            .catch(err => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
            });
    }

    //Roles
    public groupRoleRights() {
        const groups = this.roleRights.reduce((acc, curr) => {
            if (!acc[curr.GroupName]) {
                acc[curr.GroupName] = { GroupName: curr.GroupName, Actions: {} };
            }
            if (!acc[curr.GroupName].Actions[curr.DisplayName]) {
                acc[curr.GroupName].Actions[curr.DisplayName] = { DisplayName: curr.DisplayName, RoleIds: [] };
            }
            acc[curr.GroupName].Actions[curr.DisplayName].RoleIds.push(curr.RoleId);
            return acc;
        }, {});
        const result = Object.values(groups).map((group: any) => {
            group.Actions = Object.values(group.Actions);
            return group;
        });
        this.groupedRoleRights = result;
    }

    public hasPermission(action: any, roleId: number): boolean {
        return action.RoleIds.includes(roleId);
    }
}
